const Emt_Video_Tutorial_Config = [
    {
        name: "Emt_Video_Tutorial_Details",
        fields: [
            {
                id: Math.random() * 10,
                name: "title",
                label: "Title",
                type: "text",
                min: 2,
                max: Infinity,
                isRequired: true,
                autoFocus: true,
            },
            {
                id: Math.random() * 10,
                name: "language",
                label: "Language",
                type: "inputdrop",
                dropdowncontent: [
                    'ASSAMESE',     // অসমীয়া
                    'BENGALI',      // বাংলা
                    'BODO',         // बड़ो
                    'DOGRI',        // डोगरी
                    'GUJARATI',     // ગુજરાતી
                    'HINDI',        // हिन्दी
                    'KANNADA',      // ಕನ್ನಡ
                    'KASHMIRI',     // كٲشُر
                    'KONKANI',      // कोंकणी
                    'MAITHILI',     // मैथिली
                    'MALAYALAM',    // മലയാളം
                    'MANIPURI',     // মৈতৈলোন্
                    'MARATHI',      // मराठी
                    'NEPALI',       // नेपाली
                    'ODIA',         // ଓଡ଼ିଆ
                    'PUNJABI',      // ਪੰਜਾਬੀ
                    'SANSKRIT',     // संस्कृतम्
                    'SANTALI',      // ᱥᱟᱱᱛᱟᱲᱤ
                    'SINDHI',       // सिन्धी
                    'TAMIL',        // தமிழ்
                    'TELUGU',       // తెలుగు
                    'URDU',         // اردو
                    'TULU',
                    'KODAVA',
                    'KHASI',
                    'GARO',
                    'MIZO',
                    'NEPALI',
                    'BHILI',
                    'GONDHI'
                ],
                max: Infinity,
                isRequired: true,
            },
            {
                id: Math.random() * 10,
                name: "videoId",
                label: "Video Id",
                type: "text",
            },
            {
                id: Math.random() * 10,
                name: "thumbNail",
                label: "ThumbNail",
                type: "text",
            },
            {
                id: Math.random() * 10,
                name: "description",
                label: "Description",
                type: "text",
            },
            {
                id: Math.random() * 10,
                name: "serialNo",
                label: "Serial Number",
                type: "number",
            },
            {
                id: Math.random() * 10,
                name: "isLive",
                label: "Is Live",
                type: "checkbox",
            },
        ],
    },
];

export { Emt_Video_Tutorial_Config };